<template>
	<div>  
	   <br/><br/>
	   <div class="reset-header">PASSWORD RESET</div>
	   <br/>
		  <template slot="header">
			 Login
		  </template>
		  <div class="row">
			 <div class="col-md-12">
				<form @submit.prevent="requestPasswordReset">
				   <input type="email" class="form-control form-field" placeholder="Email" v-model="email">
				   <br/>
				   <br/>
				    <button class="btn btn-info ">
				    	<i class="fa fa-location-arrow"></i> Send Password Reset Link
						<span v-if="seen">
					    	<img  src="static/img/loading.gif" alt="" width="25" height="25">
						</span>
					</button>
					&nbsp;&nbsp;&nbsp;&nbsp;<router-link :to="{ name: 'Login-Layout' }"><i class="fa fa-arrow-right"></i><u>Back to Login</u></router-link>
				   <br/>
				</form>
				<br/>	
			 </div>
		  </div>
	   <div class="text-style">Copyright &copy; 2019 Blueprint Business Solution Corp<br/> version 2.1.3 beta</div>
	</div>
 </template>

<script>
/* eslint-disable */
import axios from 'axios'


export default {
 components: {
	
 },
 
 data () {
	return {
		email:'',
		seen:false,
		error_handler:'' 
	}
},


 methods:{	

	 fetchData(){
       console.log()
	 },

     requestPasswordReset(){
		axios
		    .post('api/create', {email:this.email})
            .then(resp => {
				 if(resp.data.response == 'success'){
					this.$swal({
						type: 'success',
						title: 'Done',
						text: resp.data.message,
						showConfirmButton: true,
						// timer: 3000
				     })
					 this.email = ''
				  }else if(resp.data.response == 'error'){
					this.$swal({
					 	type: 'error',
						title: 'warning',
						text: resp.data.message,
						showConfirmButton: true,
						//timer: 4000
				     })
				  }
             })
            .catch(error => {
				if (error.response.status == 422){
                      this.error_handler = error.response.data.message
                      this.$swal('Opps', this.error_handler, 'error');
                      console.log(this.error_handler)
                 }
            });
	}
 }

}
</script>
<style>
   .reset-header{
	 font-family:Calibri;
	 font-size:1.5rem;
	 color:#fff;  
   }

   .text-style{
	 font-family: sans-serif;
	 color:#fff;
	 font-size:1rem;
   }

   .r-link{
	   color: #fff;
	   text-decoration: inherit;
   }
</style>



// WEBPACK FOOTER //
// src/components/auth/reset-password/reset_password.vue